import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleIconToggleComponent } from './simple-icon-toggle.component';
export class SimpleIconToggleModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  providers: [],
  declarations: [SimpleIconToggleComponent],
  exports: [SimpleIconToggleComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SimpleIconToggleModule_tsickle_Closure_declarations() {
/** @type {?} */
SimpleIconToggleModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SimpleIconToggleModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
